import { useCallback, useEffect, useRef } from "react";
import { useNavigate, NavigateOptions, To } from "react-router-dom";

/**
 * navigate that stops working once the screen is gone.
 *
 * list screens call navigate() from an api response to sync the page number into
 * the url. on fast tab switching that response lands after the screen unmounted and
 * pulls the user back, which ping-pongs between two screens and refetches forever.
 */
export const useSafeNavigate = () => {
  const navigate = useNavigate();
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (!mounted.current) return;
      if (typeof to === "number") {
        navigate(to);
        return;
      }
      navigate(to, options);
    },
    [navigate]
  );
};
